import axios from 'axios';

const domainMap = {
    // Local
    'localhost':                    'http://api.test',
    // tumarketing3.com
    'app.tumarketing3.com':         'https://api.tumarketing3.com',
    'apk.tumarketing3.com':         'https://api.tumarketing3.com',
    'kam.tumarketing3.com':         'https://api.tumarketing3.com',
    'free.tumarketing3.com':        'https://apifree.tumarketing3.com',
    'freelance.tumarketing3.com':   'https://apifree.tumarketing3.com',
    // tmkt3.site
    'app.tmkt3.site':               'http://api.tmkt3.site',
    'kam.tmkt3.site':               'http://api.tmkt3.site',
    'adm.tmkt3.site':               'http://api.tmkt3.site',
    'admin.tmkt3.site':             'http://api.tmkt3.site',
    // tmkt3.com
    'app.tmkt3.com':                'https://api.tmkt3.com',
    'kam.tmkt3.com':                'https://api.tmkt3.com',
    'adm.tmkt3.com':                'https://api.tmkt3.com',
    'admin.tmkt3.com':              'https://api.tmkt3.com',
    'freelance.tmkt3.com':          'https://apifree.tmkt3.com',
    'free.tmkt3.com':               'https://apifree.tmkt3.com',
    'circuito.tmkt3.com':           'https://apicircuito.tmkt3.com',
};

// Temporary override to test production data from any frontend domain.
const forcedBaseUrl = 'https://apicircuito.tmkt3.com';
const baseUrl = forcedBaseUrl || domainMap[document.domain] || 'http://apifree.tmkt3.site/';
axios.defaults.baseURL = baseUrl;

//Solo para Freelancers
axios.defaults.headers.common['type'] = 'freelancer';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Accept'] = 'Application/json';

if (localStorage.getItem('token') === null || localStorage.getItem('token') === 'undefined') {
    axios.defaults.headers.common['access-token'] = '';
    axios.defaults.headers.common['api-token'] = '';
} else {
    axios.defaults.headers.common['access-token'] = localStorage.getItem('token');
    axios.defaults.headers.common['api-token'] = localStorage.getItem('token');
}

axios.interceptors.request.use(function (config) {
    return config;
}, function (error) {
    return Promise.reject(error);
})

axios.interceptors.response.use(function (response) {
    return response.data;
}, function (error) {
    if(error.response !== undefined){
        if (error.response.status === 401) {
            console.log(error.response);
        } else if (error.response.status === 500 || error.response.status === 404 || error.response.status === 400) {
            throw error;
        } else {
            return Promise.reject(error);
        }
    }
    else{
        return Promise.reject(error);
    }
})
